export function InitCalculatorSwitches() {
    let switchers = Array.from(document.querySelectorAll('.single-serviceSecOff__cats__wrapper-buttons-button[data-id]'));

    for (let switcher of switchers) {
        switcher = switcher as HTMLElement;
        if (!switcher || !switcher.getAttribute('data-id'))
            continue;
        let blocks = Array.from(document.querySelectorAll('*[data-sw-id'));
        for (let swBlock of blocks) {
            if (swBlock.getAttribute('data-sw-id') == "1")
                (swBlock as HTMLElement).style.display = null;
            else
                (swBlock as HTMLElement).style.display = "none";
        }
        switcher.addEventListener("click", (e) => {
            for (let swBlock of blocks) {
                if (swBlock.getAttribute('data-sw-id') == switcher.getAttribute('data-id'))
                    (swBlock as HTMLElement).style.display = null;
                else
                    (swBlock as HTMLElement).style.display = "none";
            }
        });
    }
}